import { render, staticRenderFns } from "./InvitedUser.vue?vue&type=template&id=c45d894a&scoped=true&"
import script from "./InvitedUser.vue?vue&type=script&lang=js&"
export * from "./InvitedUser.vue?vue&type=script&lang=js&"
import style0 from "./InvitedUser.vue?vue&type=style&index=0&id=c45d894a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45d894a",
  null
  
)

export default component.exports